const ACCOUNTS = `accounts`;
const ACCOUNT = `${ACCOUNTS}/:accountId`;

const PROJECTS = `${ACCOUNT}/projects`;
const PROJECTS_METRICS = `${PROJECTS}/conversation-metrics`;
const PROJECTS_FEATURES = `${PROJECTS}/features`;
const PROJECT = `${PROJECTS}/:projectId`;
const PUBLISH = `${PROJECT}/deployments/publish`;
const DRAFT = `${PROJECT}/draft`;

const PROJECT_FEATURES = `${PROJECT}/features`;
const DUPLICATE_PROJECT = `${PROJECT}/duplicate`;
const EXPORT_PROJECT = `${PROJECT}/export`;
const IMPORT_PROJECT = `${PROJECTS}/import`;
const PROJECT_FROM_TEMPLATE = `${PROJECTS}/from-template`;

const HANDOFFS = `${PROJECT}/handoffs`;
const HANDOFF = `${HANDOFFS}/:handoffId`;
const DEFAULT_HANDOFF = `${HANDOFFS}/default`;

const FUNCTIONS = `${PROJECT}/functions`;
const DEPLOY_FUNCTIONS = `${FUNCTIONS}/deploy`;
const FUNCTION_CUSTOM_LIB = `${FUNCTIONS}/custom_lib`;

const FUNCTION = `${FUNCTIONS}/:functionId`;
const DUPLICATE_FUNCTION = `${FUNCTION}/duplicate`;
const EXECUTE_FUNCTION = `${FUNCTION}/execute`;

const KNOWLEDGE_BASE = `${PROJECT}/knowledge-base`;
const KNOWLEDGE_BASE_IMPORT = `${PROJECT}/knowledge-base/import`;
const DISCLAIMER = `${PROJECT}/disclaimer`;
const TOPICS = `${KNOWLEDGE_BASE}/topics`;
const TOPICS_IMPORT = `${TOPICS}/import`;
const TOPICS_IMPORT_URL = `${TOPICS}/import/url`;
const TOPICS_EXPORT = `${TOPICS}/export`;
const TOPIC = `${TOPICS}/:topicId`;

const CONFIG = `${PROJECT}/config`;
const VOICE = `${PROJECT}/voice`;
const MODEL = `${PROJECT}/model`;
const VOICES = `${ACCOUNT}/voices`;
const PROMPT_EXTRACTION = `${ACCOUNT}/prompt-extraction`;
const PERSONA_EXTRACTION = `${ACCOUNT}/persona-extraction`;
const AGENT_CREATION = `${ACCOUNT}/agent-wizard/projects`;

const SAMPLE_PROJECTS = `sample-projects`;
const SAMPLE_PROJECT = `${SAMPLE_PROJECTS}/:projectId`;
const DUPLICATE_SAMPLE_PROJECT = `${SAMPLE_PROJECT}/duplicate`;

const WEBRTC_CONNECTIONS = `webrtc-connections`;
const WEBRTC_CONNECTION = `${WEBRTC_CONNECTIONS}/:connectionId`;
const DELETE_WEBRTC_CONNECTION = `${WEBRTC_CONNECTIONS}/account/:accountId/project/:projectId/:clientEnv`;

const PUBLIC_AGENTS = `agents`;
const PUBLIC_AGENT = `${PUBLIC_AGENTS}/:agentId`;
const PUBLIC_KB_TOPICS_PREVIEW = `${PUBLIC_AGENT}/knowledge-base/topics/preview`;

const VOICE_TUNING_SETTINGS = `${PROJECT}/voices/:voiceId`;
const VOICE_TUNING_TTS = `${PROJECT}/generate-audio`;
const SMS_TEMPLATES = `${PROJECT}/sms-templates`;
const SMS_TEMPLATE = `${PROJECT}/sms-templates/:smsTemplateId`;
const SMS_CREDENTIALS = `${PROJECT}/sms-credentials/:integration`;

const PARAGON = `${PROJECT}/paragon`;

const PRONUNCIATIONS = `${PROJECT}/pronunciations`;

const USER_MANAGEMENT = `users`;

const LANGUAGES = `languages`;

const INTEGRATIONS = `${PROJECT}/integrations`;
const INTEGRATIONS_START_CONNECTION = `${INTEGRATIONS}/start-connection`;
const INTEGRATIONS_NICE_MESSAGING_HANDOFF_CHANNEL = `${INTEGRATIONS}/nice-messaging-handoff/channel`;
const INTEGRATIONS_NICE_MESSAGING_HANDOFF_BOX_CREDENTIALS = `${INTEGRATIONS}/nice-messaging-handoff/integration-box-credentials`;
const MCP_TOOLS_DISCOVER = `${PROJECT}/mcp-tools/discover`;
const MCP_TOOLS_CATALOG = `${PROJECT}/mcp-tools/catalog`;

const FLOWS = `${PROJECT}/flows`;
const FLOW = `${PROJECT}/flows/:flowId`;
const DUPLICATE_FLOW = `${FLOW}/duplicate`;

const DEPLOYMENTS = `${PROJECT}/deployments`;
const DEPLOYMENTS_INITIAL = `${DEPLOYMENTS}/initial`;
const PROMOTE_DEPLOYMENT = `${DEPLOYMENTS}/:deploymentId/promote`;
const ROLLBACK_DEPLOYMENT = `${DEPLOYMENTS}/:deploymentId/rollback`;
const ACTIVE_DEPLOYMENTS = `${DEPLOYMENTS}/active`;
const DEPLOYMENT_STATE = `${DEPLOYMENTS}/:deploymentId/state`;

const AB_TESTS = `${PROJECT}/ab-tests`;
const AB_TEST = `${AB_TESTS}/:abTestId`;
const ACTIVE_AB_TEST = `${AB_TESTS}/active`;

const PHONE_NUMBERS = `${PROJECT}/numbers`;
const PHONE_NUMBER_VARIANT = `${PHONE_NUMBERS}/variant`;

const RESOURCE_METRICS = `${PROJECT}/resource-metrics`;
const SMS_TEMPLATES_USAGE_METRICS = `${RESOURCE_METRICS}/sms-templates`;

const STOP_KEYWORDS = `${PROJECT}/stop-keywords`;
const STOP_KEYWORD = `${STOP_KEYWORDS}/:stopKeywordId`;

const VARIANT_MANAGEMENT = `${PROJECT}/variant-management`;
const VARIANT_MANAGEMENT_VALUES = `${VARIANT_MANAGEMENT}/values`;

const VARIANTS = `${VARIANT_MANAGEMENT}/variants`;
const VARIANTS_EXPORT = `${VARIANTS}/export`;
const VARIANTS_IMPORT_FILE = `${VARIANTS}/import/file`;
const VARIANTS_IMPORT = `${VARIANTS}/import/diff`;
const VARIANT = `${VARIANTS}/:variantId`;

const AUDIO_CACHE = `${PROJECT}/audio-cache`;
const AUDIO_CACHE_ENTRY = `${AUDIO_CACHE}/:entryId`;
const AUDIO_CACHE_DETAILS = `${AUDIO_CACHE_ENTRY}/details`;
const AUDIO_CACHE_AUDIO_FILE = `${AUDIO_CACHE_ENTRY}/file`;
const AUDIO_CACHE_ENTRY_SYNTHESIZE = `${AUDIO_CACHE_ENTRY}/synthesize`;

const ATTRIBUTES = `${VARIANT_MANAGEMENT}/attributes`;
const ATTRIBUTE = `${ATTRIBUTES}/:attributeId`;

const TRANSCRIPT_CORRECTIONS = `${PROJECT}/asr-corrections`;
const KEYPHRASE_BOOSTING = `${PROJECT}/asr-keyphrases`;

const FUNCTIONS_LIB = `functions-lib`;

const START_CHAT = `${PROJECT}/chat`;
const RESPOND = `${PROJECT}/chat/:conversationId`;
const END_CHAT = `${PROJECT}/chat/:conversationId/end`;

const DRAFT_START_CHAT = `${DRAFT}/chat`;
const DRAFT_RESPOND = `${DRAFT}/chat/:conversationId`;

const TEMPLATE_START_CHAT = `${SAMPLE_PROJECT}/chat`;
const TEMPLATE_RESPOND = `${SAMPLE_PROJECT}/chat/:conversationId`;
const TEMPLATE_END_CHAT = `${SAMPLE_PROJECT}/chat/:conversationId/end`;

const CUSTOM_METRICS = `${PROJECT}/custom-metrics`;
const CUSTOM_METRIC = `${CUSTOM_METRICS}/:metricName`;

const CONVERSATIONS_REVIEW_SETTINGS = `${PROJECT}/conversations-review-settings`;
const CONVERSATIONS_REVIEW_VIEWS = `${CONVERSATIONS_REVIEW_SETTINGS}/views`;
const CONVERSATIONS_REVIEW_VIEW = `${CONVERSATIONS_REVIEW_VIEWS}/:viewId`;
const CUSTOM_METRICS_IMPORT = `${CUSTOM_METRICS}/import`;
const CUSTOM_METRICS_EXPORT = `${CUSTOM_METRICS}/export`;

const PROVIDER_VOICE_CONFIG = `voices/:provider/:voiceId`;
const PROVIDER_VOICE_MODEL = `voices/:provider/models`;

const CALL_BATCH = `${PROJECT}/assistant-batches/:batchId`;
const CALL_BATCHES = `${PROJECT}/assistant-batches`;
const CALL_MANUAL_BATCH = `${PROJECT}/assistant-batches/manual`;
const CALL_RANDOMISED_BATCH = `${PROJECT}/assistant-batches/randomised`;

const SCHEDULED_RESULT = `${PROJECT}/scheduled-analysis/:schedule_id`;
const SCHEDULED_RESULTS = `${PROJECT}/scheduled-analysis`;

const TASK_RESULTS = `${PROJECT}/conversations/:conversationId/tasks/:taskId/results`;

const PROJECT_CHANGE_LOGS = `${PROJECT}/logs`;
const DRAFT_CHANGE_LOGS = `${PROJECT_CHANGE_LOGS}/draft`;

const BRANCH_AUDIT = `${PROJECT}/branches/:branchId/audit`;
const PROJECT_AUDIT = `${PROJECT}/audit`;

const TELEPHONY = `${PROJECT}/telephony`;
const TELEPHONY_TOKEN = `${TELEPHONY}/token`;
const TELEPHONY_TOKENS = `${TELEPHONY_TOKEN}/list`;
const TELEPHONY_CONNECTOR = `${TELEPHONY}/connector`;

const TELEPHONY_GATEWAY_PROXY = `${PROJECT}/telephony-integrations`;

const TEST_CASE = `${PROJECT}/test-cases/:id`;
const TEST_CASE_EXTENDED = `${TEST_CASE}/extended`;
const TEST_CASES = `${PROJECT}/test-cases`;
const TRIGGER_TEST = `${TEST_CASE}/trigger`;
const TEST_HISTORY = `${PROJECT}/test-history`;
const TEST_RUNS = `${PROJECT}/test-runs`;
const TEST_RUN = `${TEST_RUNS}/:id`;
const RERUN_TEST_RUN = `${TEST_RUN}/rerun`;
const TEST_SETS = `${PROJECT}/test-sets`;
const TEST_SET = `${PROJECT}/test-sets/:id`;
const TEST_SETS_BATCH = `${TEST_SETS}/batch`;
const TRIGGER_TEST_SET = `${TEST_SET}/trigger`;
const DUPLICATE_TEST_SET = `${TEST_SET}/duplicate`;
const REMOVE_TEST_CASES = `${TEST_SET}/remove-test-cases`;

const CONVERSATION = `${PROJECT}/conversations/:conversationId`;
const CALL_REVIEW_ANNOTATIONS = `${CONVERSATION}/utterance-annotations`;

const LLM_CALL_ANNOTATIONS = `${CONVERSATION}/llm-call-annotations`;
const LLM_TURN_ANNOTATION = `${LLM_CALL_ANNOTATIONS}/turn-annotations/:turnNumber`;

const SMART_ANALYST_CHATS = `${PROJECT}/smart-analyst/chats`;
const SMART_ANALYST_CHAT = `${SMART_ANALYST_CHATS}/:chatId`;
const SMART_ANALYST_INIT_CHAT = `${SMART_ANALYST_CHATS}/init`;
const SMART_ANALYST_REVIEW_CHAT_MESSAGE = `${SMART_ANALYST_CHAT}/messages/:messageId/review`;
const SMART_ANALYST_CHATS_REASONING = `${PROJECT}/smart-analyst/reasoning/chats`;
const SMART_ANALYST_CHAT_REASONING = `${SMART_ANALYST_CHATS_REASONING}/:chatId`;
const SMART_ANALYST_CHAT_STREAM = `${SMART_ANALYST_CHAT}/stream`;
const SMART_ANALYST_TEMPLATES = `smart-analyst/templates`;

const AGENT_BUILDER_CONVERSATIONS = `${PROJECT}/agent-builder/conversations`;
const AGENT_BUILDER_CONVERSATION = `${AGENT_BUILDER_CONVERSATIONS}/:conversationId`;

const REAL_TIME_CONFIG = `${PROJECT}/real-time-configs`;
const REAL_TIME_CONFIG_CLIENT_ENV = `${REAL_TIME_CONFIG}/:clientEnv`;
const REAL_TIME_CONFIG_SCHEMA = `${REAL_TIME_CONFIG_CLIENT_ENV}/schema`;
const REAL_TIME_CONFIG_DATA = `${REAL_TIME_CONFIG_CLIENT_ENV}/config`;

const WEBCHAT_CONFIGURATIONS = `${PROJECT}/webchat-configurations`;
const POLYPHONE_CONFIGURATIONS = `${PROJECT}/polyphone-configurations`;

const SOURCE_HUB = `${PROJECT}/source-hub`;

const TRANSLATIONS = `${PROJECT}/translations`;
const TRANSLATIONS_BATCH = `${TRANSLATIONS}/batch-translation`;

const API_CONFIGS = `${ACCOUNT}/api-config`;
const API_CONFIG_PROJECT = `${PROJECT}/api-config`;
const API_KEYS = `${ACCOUNT}/api-keys`;
const PATS = `pats`;

const TEMPLATE_PROJECTS = `template-projects`;
const TEMPLATE_PROJECT = `${TEMPLATE_PROJECTS}/:accountId/:projectId`;

const INTEGRATION_RECORDS = `${PROJECT}/integration-records`;
const INTEGRATION_RECORD = `${INTEGRATION_RECORDS}/:integrationRecordId`;

const MESSAGING_HANDOFF_INTEGRATIONS = `${PROJECT}/messaging-handoff-integrations/:provider`;
const MESSAGING_HANDOFF_INTEGRATION_ENV = `${MESSAGING_HANDOFF_INTEGRATIONS}/:clientEnv`;

const ENDPOINTS = {
  ACCOUNTS,
  ACCOUNT,

  PROJECTS,
  PROJECTS_METRICS,
  PROJECTS_FEATURES,
  PROJECT,
  PUBLISH,
  DRAFT,

  DUPLICATE_PROJECT,
  IMPORT_PROJECT,
  EXPORT_PROJECT,
  PROJECT_FEATURES,
  PROJECT_FROM_TEMPLATE,

  HANDOFFS,
  HANDOFF,
  DEFAULT_HANDOFF,

  FUNCTIONS,
  DEPLOY_FUNCTIONS,
  FUNCTION,
  DUPLICATE_FUNCTION,
  EXECUTE_FUNCTION,
  FUNCTION_CUSTOM_LIB,

  KNOWLEDGE_BASE,
  KNOWLEDGE_BASE_IMPORT,
  DISCLAIMER,
  TOPICS,
  TOPICS_IMPORT,
  TOPICS_IMPORT_URL,
  TOPICS_EXPORT,
  TOPIC,

  CONFIG,
  VOICE,
  MODEL,
  VOICES,
  PROMPT_EXTRACTION,
  PERSONA_EXTRACTION,
  AGENT_CREATION,

  SAMPLE_PROJECTS,
  SAMPLE_PROJECT,
  DUPLICATE_SAMPLE_PROJECT,

  VOICE_TUNING_SETTINGS,
  VOICE_TUNING_TTS,
  SMS_TEMPLATES,
  SMS_TEMPLATE,
  SMS_CREDENTIALS,

  PARAGON,

  PRONUNCIATIONS,

  USER_MANAGEMENT,

  LANGUAGES,

  INTEGRATIONS,
  INTEGRATIONS_START_CONNECTION,
  INTEGRATIONS_NICE_MESSAGING_HANDOFF_CHANNEL,
  INTEGRATIONS_NICE_MESSAGING_HANDOFF_BOX_CREDENTIALS,
  MCP_TOOLS_DISCOVER,
  MCP_TOOLS_CATALOG,

  FLOWS,
  FLOW,
  DUPLICATE_FLOW,

  DEPLOYMENTS,
  DEPLOYMENTS_INITIAL,
  PROMOTE_DEPLOYMENT,
  ROLLBACK_DEPLOYMENT,
  ACTIVE_DEPLOYMENTS,
  DEPLOYMENT_STATE,

  AB_TESTS,
  AB_TEST,
  ACTIVE_AB_TEST,

  PHONE_NUMBERS,
  PHONE_NUMBER_VARIANT,

  SMS_TEMPLATES_USAGE_METRICS,

  STOP_KEYWORDS,
  STOP_KEYWORD,

  TRANSCRIPT_CORRECTIONS,
  KEYPHRASE_BOOSTING,

  VARIANT_MANAGEMENT,
  VARIANT_MANAGEMENT_VALUES,

  VARIANTS,
  VARIANTS_EXPORT,
  VARIANTS_IMPORT,
  VARIANTS_IMPORT_FILE,
  VARIANT,

  AUDIO_CACHE,
  AUDIO_CACHE_DETAILS,
  AUDIO_CACHE_ENTRY,
  AUDIO_CACHE_AUDIO_FILE,
  AUDIO_CACHE_ENTRY_SYNTHESIZE,

  ATTRIBUTES,
  ATTRIBUTE,

  FUNCTIONS_LIB,

  START_CHAT,
  RESPOND,
  END_CHAT,

  DRAFT_START_CHAT,
  DRAFT_RESPOND,

  TEMPLATE_START_CHAT,
  TEMPLATE_RESPOND,
  TEMPLATE_END_CHAT,

  CUSTOM_METRICS,
  CUSTOM_METRIC,
  CUSTOM_METRICS_IMPORT,
  CUSTOM_METRICS_EXPORT,

  CONVERSATIONS_REVIEW_SETTINGS,
  CONVERSATIONS_REVIEW_VIEWS,
  CONVERSATIONS_REVIEW_VIEW,

  PROVIDER_VOICE_CONFIG,
  PROVIDER_VOICE_MODEL,

  CALL_BATCH,
  CALL_BATCHES,
  CALL_MANUAL_BATCH,
  CALL_RANDOMISED_BATCH,
  TASK_RESULTS,

  SCHEDULED_RESULTS,
  SCHEDULED_RESULT,

  PROJECT_CHANGE_LOGS,
  DRAFT_CHANGE_LOGS,
  BRANCH_AUDIT,
  PROJECT_AUDIT,

  TELEPHONY,
  TELEPHONY_TOKEN,
  TELEPHONY_TOKENS,
  TELEPHONY_CONNECTOR,
  TELEPHONY_GATEWAY_PROXY,

  TEST_CASE,
  TEST_CASE_EXTENDED,
  TEST_CASES,
  TRIGGER_TEST,
  TEST_HISTORY,
  TEST_RUNS,
  TEST_RUN,
  RERUN_TEST_RUN,
  TEST_SET,
  TEST_SETS,
  TEST_SETS_BATCH,
  TRIGGER_TEST_SET,
  DUPLICATE_TEST_SET,
  REMOVE_TEST_CASES,

  CALL_REVIEW_ANNOTATIONS,

  LLM_CALL_ANNOTATIONS,
  LLM_TURN_ANNOTATION,

  SMART_ANALYST_CHATS,
  SMART_ANALYST_CHAT,
  SMART_ANALYST_INIT_CHAT,
  SMART_ANALYST_CHATS_REASONING,
  SMART_ANALYST_CHAT_REASONING,
  SMART_ANALYST_CHAT_STREAM,
  SMART_ANALYST_REVIEW_CHAT_MESSAGE,
  SMART_ANALYST_TEMPLATES,

  REAL_TIME_CONFIG,
  REAL_TIME_CONFIG_CLIENT_ENV,
  REAL_TIME_CONFIG_SCHEMA,
  REAL_TIME_CONFIG_DATA,

  WEBCHAT_CONFIGURATIONS,
  POLYPHONE_CONFIGURATIONS,

  SOURCE_HUB,

  TRANSLATIONS,
  TRANSLATIONS_BATCH,

  API_CONFIGS,
  API_CONFIG_PROJECT,
  API_KEYS,
  PATS,

  TEMPLATE_PROJECTS,
  TEMPLATE_PROJECT,

  INTEGRATION_RECORDS,
  INTEGRATION_RECORD,

  MESSAGING_HANDOFF_INTEGRATIONS,
  MESSAGING_HANDOFF_INTEGRATION_ENV,

  WEBRTC_CONNECTIONS,
  WEBRTC_CONNECTION,
  DELETE_WEBRTC_CONNECTION,
  PUBLIC_KB_TOPICS_PREVIEW,

  AGENT_BUILDER_CONVERSATIONS,
  AGENT_BUILDER_CONVERSATION,
} as const;

export const CALL_WS_ENDPOINT = `${process.env.NEXT_PUBLIC_POLYAI_BIDIRECTIONAL_MEDIA_WS}/api/v1/conversation`;

export const WEBRTC_SIGNAL_WS_ENDPOINT = `${process.env.NEXT_PUBLIC_POLYAI_WEBRTC_GATEWAY_WS}/api/v1/webrtc/signal`;

export default ENDPOINTS;
